import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { FloatingLabelSelect } from 'components/floating-label-fields';

import { ICountry, options } from './generated/country-select-input-options';
import { IProps } from './types';

/** @deprecated Use CountrySelect instead */
const CountrySelectInput: FC<IProps<HTMLSelectElement>> = ({
  name,
  label,
  value,
  validation,
  message,
  onChange,
  'data-testid': testId,
}) => {
  const { formatMessage } = useIntl();

  return (
    <FloatingLabelSelect
      name={name}
      label={label}
      value={value}
      validation={validation}
      message={message}
      onChange={onChange}
      options={options.map(function (x: ICountry) {
        return { label: formatMessage({ id: x.id }), value: x.value };
      })}
      data-testid={testId}
    />
  );
};

export default CountrySelectInput;
